import mediator, { ACTIONS } from 'mediator';
import find from 'lodash/find';
import head from 'lodash/head';
import findParentLevel from 'lib/seatmaps/findParentLevel';
import { findSeatEl } from 'lib/seats/seatFinders';

function seatFinder(seatData) {
    return function(item) {
        let seat = find(seatData, x => x.seat_no === parseInt(item.seat_no, 10));
        if (seat) {
            return findSeatEl(seat) || false;
        } else {
            return false;
        }
    }
}

export default function (currentCartItems, seatData) {
    let toSeatEl = seatFinder(seatData);
    let existingItems = currentCartItems.map(toSeatEl);
    let firstSeatEl = head(existingItems);

    if (firstSeatEl) {
        let level = findParentLevel(firstSeatEl);
        if (level) {
            mediator.publish(ACTIONS.LEVEL_PRESELECTED, level.id);
        }
    }
}



// WEBPACK FOOTER //
// ./src/javascripts/app/lib/seatmaps/preselectLevel.js